import { postData } from "@/services/api";
import Vue from "vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
//import { decompressData } from '@/services/helper'
import jpickle from '@/services/jpickle'
import pako from 'pako';
import zlib from 'zlib';
//import jpickle from 'jpickle';
import Vuelidate from "vuelidate";


Vue.use(VueToast, Vuelidate);

const state = () => ({
  // variables de los INPUTS
  formInputs: {
    name: "",
    longitude: 0,
    latitude: 0,
    depth: 0,
    equipo_list: [
      {
        id: "",
        name: "",
        sensivity: "",
        fc: "",
        gp: "",
        pref: "",
      },
    ],
    equipo_manual: {
      name: "",
      sensivity: "",
      fc: "",
      gp: "",
      pref: "agua",
    },
    equipo_selected: 1,
    sound_crop_start: 0,
    sound_crop_end: 0,
    proces_dft: false,
    proces_spl: false,
    proces_d11: false,
    proces_espec: false,
    proces_spl_data: {
      freq_start: "",
      freq_end: "",
      paso: 1,
      filtro: 1,
      orden: "",
    },
    proces_d11_data: {
      filtro: 1,
      orden: "",
    },
  },
  // Variables de ARCHIVOS SUBIDOS
  signalProps: {
    signal_nums: "",
    sampling: "",
    resolution: "",
    duration: "",
    size: "",
  },
  // variables GENERALES
  stateVars: {
    job_id: "",
    job_saved: false,
    num_files_uploaded: "",
    fileNames: [],
    jobs_list: [],
    update_jobs_list: false
  },
  filtro_list: [
    {
      id: 1,
      nombre: 'Butterworth (IIR)',
      valor: 'butter',
      tipo: 'iir',
      ventana: ''
    },
    {
      id: 2,
      nombre: 'Chebyshev Type 1 (IIR)',
      valor: 'cheby',
      tipo: 'iir',
      ventana: ''
    },
    {
      id: 3,
      nombre: 'Chebyshev Type 2 (IIR)',
      valor: 'cheby2',
      tipo: 'iir',
      ventana: ''
    },
    {
      id: 4,
      nombre: 'Hamming (FIR)',
      valor: 'fir',
      tipo: 'fir',
      ventana: 'hamming'
    },
    {
      id: 5,
      nombre: 'Blackman (FIR)',
      valor: 'fir',
      tipo: 'fir',
      ventana: 'blackman'
    },
    {
      id: 6,
      nombre: 'Bartlett (FIR)',
      valor: 'fir',
      tipo: 'fir',
      ventana: 'bartlett'
    },
    {
      id: 7,
      nombre: 'Hann (FIR)',
      valor: 'fir',
      tipo: 'fir',
      ventana: 'hann'
    }
  ],
  paso_list: [
    {
      id: 1,
      nombre: 'Octaves',
      valor: 'octavas'
    },
    {
      id: 2,
      nombre: 'Thirds',
      valor: 'tercios'
    },
    {
      id: 3,
      nombre: 'Decidecades',
      valor: 'decidecadas'
    },
    {
      id: 4,
      nombre: 'Twelfth',
      valor: 'doceavos'
    }
  ],
  // RESULTADOS
  results_DFT: {
    Y: [],
    f: [],
    m: [],
    Xlist: [],
    selec_frec: []
  },
  results_SPL: {
    SPL: [],
    freq_SPL: [],
    SPLmedia: [],
    percentiles: [],
    Merchant_X: [],
    Merchant_Y: [],
    Merchant_Z: []
  },
  results_D11: {
    SPL_C1: [],
    SPL_C1media: [],
    SPL63: [],
    SPL125: [],
    tlist: []
  },
  results_espec: {
    t: [],
    f: [],
    Sxx: [],
  },
  selected_file: 0,
  selected_results_tab: 0, // 1.- DFT / 2.- SPL / 3.- D11C1 / 4.- Espectrograma
  files_equal_size: false,
});

const mutations = {
  set_name(state, data) {
    state.formInputs.name = data;
  },
  set_longitude(state, data) {
    state.formInputs.longitude = data;
  },
  set_latitude(state, data) {
    state.formInputs.latitude = data;
  },
  set_depth(state, data) {
    state.formInputs.depth = data;
  },
  set_equip_med(state, data) {
    state.formInputs.equip_med.name = data.name;
    state.formInputs.equip_med.freq = data.freq;
  },
  set_sound_crop_start(state, data) {
    state.formInputs.sound_crop_start = data;
  },
  set_sound_crop_end(state, data) {
    state.formInputs.sound_crop_end = data;
  },
  set_proces_dft(state, data) {
    state.formInputs.proces_dft = data;
  },
  set_proces_spl(state, data) {
    state.formInputs.proces_spl = data;
  },
  // state.formInputs.proces_spl.freq_end = data.freq_end;
  // state.formInputs.proces_spl.paso = data.paso;
  // state.formInputs.proces_spl.filtro = data.filtro;
  // state.formInputs.proces_spl.orden = data.orden;
  set_proces_spl_data_freq_start(state, data) {
    state.formInputs.proces_spl_data.freq_start = data;
  },
  set_proces_spl_data_freq_end(state, data) {
    state.formInputs.proces_spl_data.freq_end = data;
  },
  set_proces_spl_data_paso(state, data) {
    state.formInputs.proces_spl_data.paso = data;
  },
  set_proces_spl_data_filtro(state, data) {
    state.formInputs.proces_spl_data.filtro = data;
  },
  set_proces_spl_data_orden(state, data) {
    state.formInputs.proces_spl_data.orden = data;
  },
  set_proces_d11(state, data) {
    state.formInputs.proces_d11 = data;
  },
  set_proces_d11_data_filtro(state, data) {
    state.formInputs.proces_d11_data.filtro = data;
  },
  set_proces_d11_data_orden(state, data) {
    state.formInputs.proces_d11_data.orden = data;
  },
  set_proces_espec(state, data) {
    state.formInputs.proces_espec = data;
  },
  set_equipo_list(state, data){
    state.formInputs.equipo_list = data
  },
  set_equipo_selected(state, data){
    state.formInputs.equipo_selected = data
  },
  set_equipo_manual_name(state, data) {
    state.formInputs.equipo_manual.name = data
  },
  set_equipo_manual_sensivity(state, data) {
    state.formInputs.equipo_manual.sensivity = data
  },
  set_equipo_manual_fc(state, data) {
    state.formInputs.equipo_manual.fc = data
  },
  set_equipo_manual_gp(state, data) {
    state.formInputs.equipo_manual.gp = data
  },
  set_equipo_manual_pref(state, data) {
    state.formInputs.equipo_manual.pref = data
  },
  // Variables de ARCHIVOS SUBIDOS
  set_signal_props(state, data) {
    state.signalProps = data
  },
  set_signal_nums(state, data) {
    state.signalProps.signal_nums = data;
  },
  // Variables GENERALES
  set_job_id(state, data) {
    state.stateVars.job_id = data;
  },
  set_job_saved(state, data) {
    state.stateVars.job_saved = data;
  },
  set_num_files_uploaded(state, data) {
    state.stateVars.num_files_uploaded = data
  },
  set_fileNames(state, data) {
    state.stateVars.fileNames = data;
  },
  set_jobs_list(state, data) {
    state.stateVars.jobs_list = data;
  },
  set_update_jobs_list(state, data) {
    state.stateVars.update_jobs_list = data;
  },
  // Resultados
  set_results_DFT(state, data) {
    state.results_DFT = data
  },
  set_results_SPL(state, data) {
    state.results_SPL = data
  },
  set_results_D11(state, data) {
    state.results_D11 = data
  },
  set_results_espec(state, data) {
    state.results_espec = data
  },
  set_selected_file(state, data) {
    state.selected_file = data
  },
  set_selected_results_tab(state, data) {
    state.selected_results_tab = data
  },
  set_files_equal_size(state, data) {
    state.files_equal_size = data
  }
};

const actions = {
  change_name({ commit }, data) {
    commit("set_name", data);
  },
  change_longitude({ commit }, data) {
    commit("set_longitude", data);
  },
  change_latitude({ commit }, data) {
    commit("set_latitude", data);
  },
  change_depth({ commit }, data) {
    commit("set_depth", data);
  },
  change_proces_dft({ commit }, data) {
    commit("set_proces_dft", data);
  },
  change_proces_spl({ commit }, data) {
    commit("set_proces_spl", data);
  },
  change_proces_spl_data_freq_start({ commit }, data) {
    commit("set_proces_spl_data_freq_start", data);
  },
  change_proces_spl_data_freq_end({ commit }, data) {
    commit("set_proces_spl_data_freq_end", data);
  },
  change_proces_spl_data_paso({ commit }, data) {
    commit("set_proces_spl_data_paso", data);
  },
  change_proces_spl_data_filtro({ commit }, data) {
    commit("set_proces_spl_data_filtro", data);
  },
  change_proces_spl_data_orden({ commit }, data) {
    commit("set_proces_spl_data_orden", data);
  },

  // change_proces_spl_data({ commit }, data) {
  //   commit("set_proces_spl_data", data);
  // },
  change_proces_d11({ commit }, data) {
    commit("set_proces_d11", data);
  },
  change_proces_d11_data_filtro({ commit }, data) {
    commit("set_proces_d11_data_filtro", data);
  },
  change_proces_d11_data_orden({ commit }, data) {
    commit("set_proces_d11_data_orden", data);
  },
  change_proces_espec({ commit }, data) {
    commit("set_proces_espec", data);
  },
  change_equipo_list({ commit }, data) {
    commit("set_equipo_list", data);
  },
  change_equipo_selected({ commit }, data) {
    commit("set_equipo_selected", data);
  },
  change_sound_crop_start({ commit }, data) {
    commit("set_sound_crop_start", data);
  },
  change_sound_crop_end({ commit }, data) {
    commit("set_sound_crop_end", data);
  },
  change_equipo_manual_name({ commit }, data) {
    commit("set_equipo_manual_name", data)
  },
  change_equipo_manual_sensivity({ commit }, data) {
    commit("set_equipo_manual_sensivity", data)
  },
  change_equipo_manual_fc({ commit }, data) {
    commit("set_equipo_manual_fc", data)
  },
  change_equipo_manual_gp({ commit }, data) {
    commit("set_equipo_manual_gp", data)
  },
  change_equipo_manual_pref({ commit }, data) {
    commit("set_equipo_manual_pref", data)
  },
  // Variables de archivos subidos
  change_signal_props({ commit }, data) {
    commit("set_signal_props", data)
  },
  change_signal_nums({ commit }, data) {
    commit("set_signal_nums", data)
  },
  // Variables generales
  change_job_id({ commit }, data) {
    commit("set_job_id", data)
  },
  change_job_saved({ commit }, data) {
    commit("set_job_saved", data)
  },
  change_num_files_uploaded({ commit }, data) {
    commit("set_num_files_uploaded", data)
  },
  change_fileNames({ commit }, data) {
    commit("set_fileNames", data)
  },
  change_jobs_list({ commit }, data) {
    commit("set_jobs_list", data)
  },
  change_update_jobs_list({ commit }, data) {
    commit("set_update_jobs_list", data)
  },
  // Resultados
  change_selected_file({ commit }, data) {
    commit("set_selected_file", data)
  },
  change_selected_results_tab({ commit }, data) {
    commit("set_selected_results_tab", data)
  },
  change_files_equal_size({ commit }, data) {
    commit("set_files_equal_size", data)
  },

  // ACCIÓN PARA COMENZAR EL PROCESADO
  submit_processing({ commit, dispatch, getters }) {
    console.log("Entra a la acción")
    // Set 'loading' status

    if(!getters['formInput'].sound_crop_end)
        getters['formInput'].sound_crop_end = 0
    if(!getters['formInput'].sound_crop_start)
        getters['formInput'].sound_crop_start = 0

    dispatch("ui/change_current_interface", null, { root: true });
    dispatch("ui/change_status", 2, { root: true });
    if(getters['proces_dft'] == true || getters['proces_dft'] == 'true'){
      dispatch("ui/change_loading_dft", 1, { root: true });
    }
    if(getters['proces_spl'] == true || getters['proces_spl'] == 'true'){
      dispatch("ui/change_loading_spl", 1, { root: true });
    }
    if(getters['proces_d11'] == true || getters['proces_d11'] == 'true'){
      dispatch("ui/change_loading_d11", 1, { root: true });
    }
    if(getters['proces_espec'] == true || getters['proces_espec'] == 'true'){
      dispatch("ui/change_loading_espec", 1, { root: true });
    }

    let formData = new FormData()
    for (const key in getters['formInput']) {
      if (key == "equipo_list" || key == "equipo_selected" || key == "equipo_manual" || key == "proces_spl_data" || key == "proces_d11_data"){
        console.log('No enter')
      } 
      else {
        formData.append(key, getters['formInput'][key]);
        console.log(key + ': ' + getters['formInput'][key])
      }   
    }

    // EQUIPO
    let sensivity = ''
    let fc = ''
    let gp = ''
    let pref = ''
    if (getters['formInput'].equipo_selected == 0) {
      sensivity = getters['formInput'].equipo_manual.sensivity
      fc = getters['formInput'].equipo_manual.fc
      gp = getters['formInput'].equipo_manual.gp
      pref = getters['formInput'].equipo_manual.pref
    } else {
      sensivity = getters['formInput'].equipo_list[parseFloat(getters['formInput'].equipo_selected) - 1].sensivity
      fc = getters['formInput'].equipo_list[parseFloat(getters['formInput'].equipo_selected) - 1].fc
      gp = getters['formInput'].equipo_list[parseFloat(getters['formInput'].equipo_selected) - 1].gp
      pref = getters['formInput'].equipo_list[parseFloat(getters['formInput'].equipo_selected) - 1].pref
      if (pref == 'Agua') pref = 'agua'
      if (pref == 'Aire') pref = 'aire'
    }
    formData.append('sensivity', sensivity)
    console.log('sensivity: ', sensivity)
    formData.append('fc', fc)
    console.log('fc: ', fc)
    formData.append('gp', gp)
    console.log('gp: ', gp)
    formData.append('pref', pref)
    console.log('pref: ', pref)

    // SPL
    formData.append('spl_f_start', getters['proces_spl_data_freq_start'])
    console.log('spl_f_start: ', getters['proces_spl_data_freq_start'])
    formData.append('spl_f_end', getters['proces_spl_data_freq_end'])
    console.log('spl_f_end: ', getters['proces_spl_data_freq_end'])
    formData.append('spl_paso', getters['paso_list'][parseFloat(getters['proces_spl_data_paso']) -1].valor)
    console.log('spl_paso: ', getters['paso_list'][parseFloat(getters['proces_spl_data_paso']) -1].valor)
    formData.append('spl_filtro', getters['filtro_list'][parseFloat(getters['proces_spl_data_filtro']) -1].valor)
    console.log('spl_filtro: ', getters['filtro_list'][parseFloat(getters['proces_spl_data_filtro']) -1].valor)
    formData.append('spl_filtro_tipo', getters['filtro_list'][parseFloat(getters['proces_spl_data_filtro']) -1].tipo)
    console.log('spl_filtro_tipo: ', getters['filtro_list'][parseFloat(getters['proces_spl_data_filtro']) -1].tipo)
    formData.append('spl_filtro_ventana', getters['filtro_list'][parseFloat(getters['proces_spl_data_filtro']) -1].ventana)
    console.log('spl_filtro_ventana: ', getters['filtro_list'][parseFloat(getters['proces_spl_data_filtro']) -1].ventana)
    formData.append('spl_orden', getters['proces_spl_data_orden'])
    console.log('spl_orden: ', getters['proces_spl_data_orden'])

    // D11
    formData.append('d11_filtro', getters['filtro_list'][parseFloat(getters['proces_d11_data_filtro']) -1].valor)
    console.log('d11_filtro: ', getters['filtro_list'][parseFloat(getters['proces_d11_data_filtro']) -1].valor)
    formData.append('d11_filtro_tipo', getters['filtro_list'][parseFloat(getters['proces_d11_data_filtro']) -1].tipo)
    console.log('d11_filtro_tipo: ', getters['filtro_list'][parseFloat(getters['proces_d11_data_filtro']) -1].tipo)
    formData.append('d11_filtro_ventana', getters['filtro_list'][parseFloat(getters['proces_d11_data_filtro']) -1].ventana)
    console.log('d11_filtro_ventana: ', getters['filtro_list'][parseFloat(getters['proces_d11_data_filtro']) -1].ventana)
    formData.append('d11_orden', getters['proces_d11_data_orden'])
    console.log('d11_orden: ', getters['proces_d11_data_orden'])

    // JOB ID
    formData.append('job_id', getters['job_id'])
    console.log('job_id: ', getters['job_id'])
    
    // USER ID
    formData.append('user_id', localStorage.user_id)
    console.log('user_id: ', localStorage.user_id)

    // POST FORM DATA
    postData('processing/processdata/', formData)
    .then((res) => {
      if (res.status == "200") {
        //commit("set_transect_1", res.data.transect_1);
        //commit("set_transect_2", res.data.transect_2);
        console.log("YEP!")
        //commit("set_results_DFT", res.data.DFT)
        //commit("set_results_SPL", res.data.SPL)

      } else {
        dispatch("ui/change_current_interface", 7, { root: true });
        dispatch("ui/change_status", 1, { root: true });
        Vue.$toast.open({
          message: "Something went wrong. Process stopped.",
          type: "error",
          position: "top",
          pauseOnHover: true,
          duration: 6000,
        });
      }
    })
    .catch((err) => console.log(err)); 
  },
  // ACCIÓN PARA TRAER RESULTADOS DEL BACK END
  getResults({ commit, dispatch, getters, rootGetters }, data) {
    if(rootGetters['ui/current_interface'] != 8) {
      dispatch("ui/change_status", 2, { root: true });
    }
    let job_id = data[0]
    let job_type = data[1]
    if(job_type == 'dft'){
      dispatch("ui/change_loading_dft", 2, { root: true });
    }
    else if(job_type == 'spl'){
      dispatch("ui/change_loading_spl", 2, { root: true });
    }
    else if(job_type == 'd11'){
      dispatch("ui/change_loading_d11", 2, { root: true });
    }
    else if(job_type == 'espec'){
      dispatch("ui/change_loading_espec", 2, { root: true });
    }
    let url = 'processing/get' + job_type + '/'
    let formData = new FormData()
    formData.append('job_id', job_id)
    postData(url, formData)
    .then( (res) => {
      if (res.status == "200") {
        commit("set_fileNames", res.data.fileNames)
        if (job_type == 'dft') {
          console.log("Got DFT")
          dispatch("ui/change_loading_dft", 0, { root: true });  
          commit("set_results_DFT", res.data.DFT)
          if (getters['selected_results_tab'] == 0) {
            commit("set_selected_results_tab", 1)
          }
        }
        else if (job_type == 'spl') {
          console.log("Got SPL")
          dispatch("ui/change_loading_spl", 0, { root: true });  
          commit("set_results_SPL", res.data.SPL)
          if (getters['selected_results_tab'] == 0) {
            commit("set_selected_results_tab", 2)
          }
        }
        else if (job_type == 'd11') {
          console.log("Got D11")
          dispatch("ui/change_loading_d11", 0, { root: true });  
          commit("set_results_D11", res.data.D11)
          if (getters['selected_results_tab'] == 0) {
            commit("set_selected_results_tab", 3)
          }
        }
        else if (job_type == 'espec') {
          console.log("Got espectrograma")
          try {
            console.log('res ok')
            let res_1 = jpickle.loads('U\x0bhello worldq\x01.');
            console.log(res_1)
            console.log('\x80\x03]q\x00(]q\x01(]q\x02(G>\x93\xff\x99\xdc=5\xc9G>\xad\xfff\xca[\xd0\xaee]q\x03(G>\x88\x06d\xa6\xa6P\x14G>\xc1\x07dM\\\x7f2ee]q\x04(]q\x05(G>\x9a\xb5\x96\x82\xeca\x9bG>\xad\xfff\xca[\xd0\xaee]q\x06(G>\xa3m\x92w\x07\xeb\xa9G>\xc1\x07dM\\\x7f2eee.')
            let res_2 = jpickle.loads('\x80\x03]q\x00(]q\x01(]q\x02(G>\x93\xff\x99\xdc=5\xc9G>\xad\xfff\xca[\xd0\xaee]q\x03(G>\x88\x06d\xa6\xa6P\x14G>\xc1\x07dM\\\x7f2ee]q\x04(]q\x05(G>\x9a\xb5\x96\x82\xeca\x9bG>\xad\xfff\xca[\xd0\xaee]q\x06(G>\xa3m\x92w\x07\xeb\xa9G>\xc1\x07dM\\\x7f2eee.');
            console.log(res_2)

            const compressedData = new Uint8Array([
              0x1f, 0x8b, 0x08, 0x00, 0x76, 0xce, 0x75, 0x64, 0x02, 0xff, 0x6b, 0x60, 0x8e, 0x2d, 0xd0, 0x88, 0x2d, 0x04, 0x62, 0x26,
              0x0d, 0x77, 0xbb, 0xc9, 0xff, 0x67, 0xde, 0xb1, 0x35, 0x3d, 0xe9, 0x6e, 0xb7, 0xf6, 0x7f, 0xda, 0xa9, 0xe8, 0x0b, 0xeb,
              0x52, 0x63, 0x0b, 0x99, 0x81, 0xc2, 0x1d, 0x6d, 0x29, 0xcb, 0x96, 0x05, 0x88, 0xb8, 0xdb, 0x1d, 0x64, 0x4f, 0xf1, 0x8d,
              0xa9, 0x37, 0x4a, 0x05, 0x8a, 0xb3, 0x00, 0xb5, 0xb0, 0x02, 0xe5, 0x66, 0x6d, 0x9d, 0xd6, 0xf4, 0x26, 0x71, 0x36, 0xb2,
              0x16, 0x61, 0xf0, 0xe2, 0xdc, 0x49, 0xe5, 0xec, 0xaf, 0x57, 0x22, 0x69, 0x49, 0xd5, 0x03, 0x00, 0x9f, 0xff, 0xea, 0xc1,
              0x6e, 0x00, 0x00, 0x00
            ])

    
            //const uncompressedData2 = pako.inflate(compressedData);
            // console.log(uncompressedData2)
            
            //let compressed_data = res.data.compressed_data
        
            //compressed_data = compressed_data.substring(2, compressed_data.length-1)
            //let decompressedEspec = await this.decompressData(res.data.espec)
            //let resEspec = res.data.espec

            //console.log(compressed_data)
      
          // const compressedBuffer = Buffer.from(atob(res.data.compressed_data), 'binary');
          // console.log(compressedBuffer)
          // console.log(compressedBuffer.length)
          // let inflatedData = pako.inflate(compressedBuffer,{ to: 'string'});

          //inflatedData = inflatedData.substring(1, inflatedData.length-1)
          //console.log(inflatedData)


          // let aaa = '\x80\x03cnumpy.core.multiarray\n_reconstruct\nq\x00cnumpy\nndarray\nq\x01K\x00\x85q\x02C\x01bq\x03\x87q\x04Rq\x05(K\x01K\x02K\x02K\x02\x87q\x06cnumpy\ndtype\nq\x07X\x02\x00\x00\x00f8q\x08K\x00K\x01\x87q\tRq\n(K\x03X\x01\x00\x00\x00<q\x0bNNNJ\xff\xff\xff\xffJ\xff\xff\xff\xffK\x00tq\x0cb\x89C@\xc95=\xdc\x99\xff\x93>\xae\xd0[\xcaf\xff\xad>\x14P\xa6\xa6d\x06\x88>2\x7f\\Md\x07\xc1>\x9ba\xec\x82\x96\xb5\x9a>\xae\xd0[\xcaf\xff\xad>\xa9\xeb\x07w\x92m\xa3>2\x7f\\Md\x07\xc1>q\rtq\x0eb.'
          
          // let decodedData2 = jpickle.loads(aaa)
          // console.log(decodedData2)

          // let decodedData = jpickle.loads(inflatedData)
          // console.log(decodedData)

            //const compressedData = Uint8Array.from(atob(res.data.compressed_dat), c => c.charCodeAt(0));
            //console.log(compressedData)
            // const decodedData = atob(res.data.compressed_data);
            // console.log(decodedData)


            // Convertir la cadena decodificada en un array de bytes
            // const byteArray = new Uint8Array(decodedData.length);
            // for (let i = 0; i < decodedData.length; i++) {
            //   byteArray[i] = decodedData.charCodeAt(i);
            // }
            // console.log(byteArray)
            // const string = 'x\x9ck`\x8e-d\xd0\x88-d\x04b&\rw\xbb\xc9\xffg\xde\xb15=\xe9n\xb7\xf6\x7f\xda\xa9\xe8\x0b\xebRc\x0b\x99\x81\xc2\x1dl)\xcb\x96\x05\x88\xb8\xdb\x1ddO\xf1\x8d\xa97J\x05\x8a\xb3\x00\xb5\xb0\x02\xe5fm\x9d\xd6\xf4&q6\xb2\x166\xa0\xf0\xe2\xdcI\xe5\xec\xafW"iI\xd5\x03\x00Cq+\xc9';

            // const encoder = new TextEncoder();
            // const uint8Array = encoder.encode(string);

            // console.log(uint8Array);

            // zlib.gunzip(compressedData, (err, uncompressedData) => {
            //   if (err) {
            //     console.error('Error al descomprimir los datos:', err);
            //     return;
            //   }
            //   console.log(uncompressedData)
           
            // });

            //const uncompressedData = pako.inflate(compressed_data_8Array);
            //console.log(uncompressedData)
            //const uncompressedBuffer = zlib.gunzipSync(compressedBuffer);
            
            // console.log(Array.from(uncompressedData))




            //console.log(decodeURIComponent(res.data.espec_Sxx))
      
            // const pickleuncompressedData = pickle.loads(uncompressedData)
            // console.log(pickleuncompressedData)

            // const uncompressedbyteArray =  new Uint8Array(uncompressedData.length)
            // for (let i = 0; i < uncompressedData.length; i++) {
            //   uncompressedbyteArray[i] = uncompressedData.charCodeAt(i);
            // }

            // console.log(uncompressedbyteArray)
            // const uncompressedbyteArray = new Uint8Array(uncompressedData)
            // console.log(uncompressedbyteArray)

            // const stringData = new TextDecoder('utf-8').decode(uncompressedData);
            // console.log(stringData)


            // const deserializedData = pickle.loads(stringData)
            // console.log(deserializedData)

            //const jsonString = new TextDecoder('utf-8').decode(uncompressedData);

            
            // Analizar el JSON resultante
            //const parsedData = JSON.parse(uncompressedData);
            //const parsedData = pickle.loads(uncompressedData);

          

            // const array_1 = pickle.loads(uncompressedData);
            // console.log(array_1[0]);

            //let inflatedData = pako.inflate(res.data, { to: 'string' });
            //console.log(inflatedData)
            // let redData = JSON.parse(pako.inflate(res.data.encoded_data, { raw: true }));
            // console.log(redData)
            // let espec_Sxx = pako.inflate(res.data.espec_Sxx);
            // console.log(espec_Sxx)
            // redData.espec.espec_Sxx = espec_Sxx;
            
            //serialized_data = JSON.parse(json_data)
            //resEspec.espec_Sxx = pako.inflate(JSON.parse(resEspec.espec_Sxx));
            //resEspec.espec_Sxx =  await this.decompressData(JSON.parse(resEspec.espec_Sxx))
            
        
            dispatch("ui/change_loading_espec", 0, { root: true });  
            commit("set_results_espec", res.data.espec)
            if (getters['selected_results_tab'] == 0) {
              commit("set_selected_results_tab", 4)
            }

          } catch (error) {
            console.error('Error en la descompresión:', error);
          }
        }
        // Remove 'loading' status and display results
        dispatch("ui/change_current_interface", 8, { root: true });
        dispatch("ui/change_status", 1, { root: true });
      }
    })
  },
  // ACCIÓN PARA RESETEAR FORMS
  reset({ commit }) {
    commit("set_job_id", '')
    commit("set_name", '')
    commit("set_job_saved", false)
    commit("set_longitude", 0)
    commit("set_latitude", 0)
    commit("set_depth", 0)
    commit("set_fileNames", [])
    commit("set_signal_props", {
      signal_nums: "",
      sampling: "",
      resolution: "",
      duration: "",
      size: "",
    })
    commit("set_selected_file", 0)
    commit("set_selected_results_tab", 0)
    commit("set_results_DFT", {
      Y: [],
      f: [],
      m: [],
      Xlist: [],
      selec_frec: []
    })
    commit("set_results_SPL", {
      SPL: [],
      freq_SPL: [],
      SPLmedia: [],
      percentiles: [],
      Merchant_X: [],
      Merchant_Y: [],
      Merchant_Z: []
    })
    commit("set_results_D11", {
      SPL_C1: [],
      SPL_C1media: [],
      SPL63: [],
      SPL125: [],
      tlist: []
    })
    commit("set_results_espec", {
      t: [],
      f: [],
      Sxx: []
    })
  }
};

const getters = {
  // Objeto con todos los inputs
  formInput: (state) => state.formInputs,

  // Objetos individuales
  name: (state) => state.formInputs.name,
  longitude: (state) => state.formInputs.longitude,
  latitude: (state) => state.formInputs.latitude,
  depth: (state) => state.formInputs.depth,
  equip_med: (state) => state.formInputs.equip_med,
  sound_crop_start: (state) => state.formInputs.sound_crop_start,
  sound_crop_end: (state) => state.formInputs.sound_crop_end,
  proces_dft: (state) => state.formInputs.proces_dft,
  proces_spl: (state) => state.formInputs.proces_spl,
  proces_spl_data: (state) => state.formInputs.proces_spl_data,
  proces_spl_data_freq_start: (state) =>
    state.formInputs.proces_spl_data.freq_start,
  proces_spl_data_freq_end: (state) =>
    state.formInputs.proces_spl_data.freq_end,
  proces_spl_data_paso: (state) => state.formInputs.proces_spl_data.paso,
  proces_spl_data_filtro: (state) => state.formInputs.proces_spl_data.filtro,
  proces_spl_data_orden: (state) => state.formInputs.proces_spl_data.orden,
  proces_d11: (state) => state.formInputs.proces_d11,
  proces_d11_data: (state) => state.formInputs.proces_d11_data,
  proces_d11_data_filtro: (state) => state.formInputs.proces_d11_data.filtro,
  proces_d11_data_orden: (state) => state.formInputs.proces_d11_data.orden,
  proces_espec: (state) => state.formInputs.proces_espec,
  equipo_list: (state) => state.formInputs.equipo_list,
  equipo_selected: (state) => state.formInputs.equipo_selected,
  sound_crop_start: (state) => state.formInputs.sound_crop_start,
  sound_crop_end: (state) => state.formInputs.sound_crop_end,
  
  
  signal_props: (state) => state.signalProps,
  signal_nums: (state) => state.signalProps.signal_nums,
  job_id: (state) => state.stateVars.job_id,
  job_saved: (state) => state.stateVars.job_saved,
  num_files_uploaded: (state) => state.stateVars.num_files_uploaded,
  fileNames: (state) => state.stateVars.fileNames,
  jobs_list: (state) => state.stateVars.jobs_list,
  update_jobs_list: (state) => state.stateVars.update_jobs_list,

  filtro_list: (state) => state.filtro_list,
  paso_list: (state) => state.paso_list,

  // Results
  results_DFT: (state) => state.results_DFT,
  results_SPL: (state) => state.results_SPL,
  results_D11: (state) => state.results_D11,
  results_espec: (state) => state.results_espec,
  selected_file: (state) => state.selected_file,
  selected_results_tab: (state) => state.selected_results_tab,
  files_equal_size: (state) => state.files_equal_size,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  VueToast,
  Vuelidate,
};
